type SocialAccount = { platform: string; urlOrHandle: string }

export function mapBsSocialPlatforms(socialAccounts: SocialAccount[] = []): Record<string, string> {
  const supportedPlatforms = ['linkedin', 'instagram', 'facebook', 'youtube', 'twitter', 'whatsApp']
  return socialAccounts.reduce<Record<string, string>>((accumulator, currentValue) => {
    const platform = currentValue.platform.toLowerCase().replace('_a', 'A') // .replace() Caters for WHATS_APP
    if (supportedPlatforms.includes(platform)) {
      accumulator[platform] = currentValue.urlOrHandle
    }
    return accumulator
  }, {})
}

export function getWebsite(socialAccounts: SocialAccount[]): string | undefined {
  const websitePlatform = socialAccounts.find((account) => account.platform === 'WEBSITE')
  if (websitePlatform) return websitePlatform.urlOrHandle
  return undefined
}
